import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AuditTrailDTO, AuditTrailTableDTO } from '../../../core/interface/audit-trail.interface';
import { AppModalService } from '../../../core/services/app-modal.service';
import { PaginationBase } from '../../../core/class/pagination-base';
import { AppPagination } from '../app-pagination/app-pagination';

@Component({
  selector: 'app-audit-trail-modal',
  standalone: true,
  imports: [AppPagination],
  templateUrl: './audit-trail-modal.html',
  styleUrl: './audit-trail-modal.scss',
})
export class AuditTrailModal extends PaginationBase<AuditTrailTableDTO> implements OnInit {
  @ViewChild('modalRef')
  modalRef!: ElementRef<HTMLElement>;
  isAuditVisible = false;
  title = '';
  columns: string[] = [];
  positionX = 0;
  positionY = 0;
  override data: AuditTrailTableDTO[] = [];
  pageSizeOptions = [50, 100, 200, 500];

  constructor(private readonly appModalService: AppModalService) {
    super();
    this.pageSize = 100;
  }

  ngOnInit(): void {
    this.appModalService.auditState$.subscribe((auditData: AuditTrailDTO) => {
      this.title = auditData.title;
      this.columns = auditData.columns;
      this.data = auditData.data;
      this.currentPage = 1;
      this.isAuditVisible = true;
      setTimeout(() => {
        this.centerModal();
      });
    });
  }

  // Get the value of a cell, with special formatting for date fields in 'Old Value' and 'New Value' columns
  getCellValue(row: AuditTrailTableDTO, column: string): string | string[] {
    const value = row[column];
    // Format dates for dateReviewed and dateCorptaxAdj fields
    if (column === 'Old Value' || column === 'New Value') {
      const fieldName = row['Field Name'] as string;
      if ((fieldName === 'dateReviewed' || fieldName === 'dateCorptaxAdj') && value) {
        if (Array.isArray(value)) {
          return value.map((v) => {
            if (v) {
              try {
                const formatted = new Intl.DateTimeFormat('en-US', {
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: true,
                }).format(new Date(v as string));
                return formatted.replace(', ', ' ');
              } catch {
                return v;
              }
            }
            return v;
          });
        } else if (typeof value === 'string') {
          try {
            const formatted = new Intl.DateTimeFormat('en-US', {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
              second: '2-digit',
              hour12: true,
            }).format(new Date(value as string));
            return formatted.replace(', ', ' ');
          } catch {
            return value;
          }
        }
      }
    }
    return value;
  }

  isArray(value: string | string[]): value is string[] {
    return Array.isArray(value);
  }

  onPageChange(page: number): void {
    this.changePage(page);
  }

  onPageSizeChange(size: number): void {
    this.changePageSize(size);
  }

  private centerModal(): void {
    if (!this.modalRef) {
      return;
    }
    const pos = this.appModalService.centerModal(this.modalRef.nativeElement);
    this.positionX = pos.positionX;
    this.positionY = pos.positionY;
  }

  startDrag(event: MouseEvent): void {
    this.appModalService.startDrag(event, this.positionX, this.positionY);
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    const pos = this.appModalService.drag(event);
    if (!pos) {
      return;
    }
    this.positionX = pos.positionX;
    this.positionY = pos.positionY;
  }

  @HostListener('document:mouseup')
  onMouseUp(): void {
    this.appModalService.stopDrag();
  }

  close(): void {
    this.isAuditVisible = false;
  }
}
